import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";
import ProfilePicture from "@Shared/components/settings/account/profile-picture.vue";
import ChangePassword from "@Shared/components/settings/account/change-password.vue";
import PersonalDetails from "@Shared/components/settings/account/personal-details.vue";
import ProfileContainerLoader from "./profile-container-loader.vue";
import { LOAD_PERSONAL_DETAILS, UPDATE_PERSONAL_DETAILS, UPDATE_PASSWORD, LOAD_ACCOUNT_DETAILS, UPDATE_ACCOUNT_DETAILS, UPDATE_PROFILE_PHOTO, REMOVE_PROFILE_PHOTO, UPDATE_LOCALE_PREFERENCES } from "@Client/@Modules/main/store/account/account-actions";
import { showToast } from "@Shared/utils/constants";
import LanguagePreferences from "@Shared/components/settings/account/language-preferences.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ProfileContainer",
  components: {
    ProfilePicture,
    ChangePassword,
    PersonalDetails,
    LanguagePreferences,
    ProfileContainerLoader
  },
  props: {
    saving: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      formsWaiting: 0,
      loading: false,
      formsChanged: [],
      formsWithError: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("AccountStore", ["userDetails", "accountDetails"])), {}, {
    session() {
      return this.data.session;
    },
    subdomain() {
      return this.data.accountDetails.accountSubdomain;
    }
  }),
  watch: {
    formsWaiting(newValue, oldValue) {
      if (oldValue !== 0 && newValue === 0) {
        showToast("success", "profileUpdated");
        this.loading = false;
        this.$nextTick(() => {
          this.$refs.changePasswordForm.clearPasswords();
        });
      }
    },
    saving(value) {
      if (!value) return;
      this.handleSubmit();
    }
  },
  async mounted() {
    this.loading = true;
    await this.LOAD_ACCOUNT_DETAILS();
    await this.LOAD_PERSONAL_DETAILS();
    this.loading = false;
  },
  methods: _objectSpread(_objectSpread({}, mapActions("AccountStore", [LOAD_PERSONAL_DETAILS, UPDATE_PERSONAL_DETAILS, LOAD_ACCOUNT_DETAILS, UPDATE_ACCOUNT_DETAILS, UPDATE_PASSWORD, UPDATE_PROFILE_PHOTO, REMOVE_PROFILE_PHOTO, UPDATE_LOCALE_PREFERENCES])), {}, {
    handleSubmit() {
      this.loading = true;
      this.formsChanged.forEach(form => this.$refs[`${form}Form`].handleSubmit());
      this.formsChanged = [];
      this.$emit("finish-saving", true);
    },
    async handlePersonalDetailsSubmit(userDetails) {
      try {
        this.formsWaiting++;
        const accountDetails = {
          timezone: userDetails.timezone
        };
        await _Promise.all([this.UPDATE_ACCOUNT_DETAILS(accountDetails), this.UPDATE_PERSONAL_DETAILS(userDetails)]);
      } catch (e) {
        this.formsWithError.push("personalDetails");
      } finally {
        this.formsWaiting--;
      }
    },
    async handlePasswordSubmit(passwords) {
      try {
        var _context;
        this.formsWaiting++;
        await this.UPDATE_PASSWORD(_objectSpread(_objectSpread({}, passwords), {}, {
          email: this.userDetails.email
        }));
        this.formsWithError = _filterInstanceProperty(_context = this.formsWithError).call(_context, form => form !== "changePassword");
      } catch (e) {
        this.formsWithError.push("changePassword");
      } finally {
        this.formsWaiting--;
      }
    },
    async handleUploadProfilePhoto(croppedImage) {
      this.formsWaiting++;
      this.loading = true;
      await this.UPDATE_PROFILE_PHOTO({
        croppedImage,
        username: this.userDetails.username
      });
      this.formsWaiting--;
    },
    async handleRemoveProfilePhoto() {
      this.formsWaiting++;
      this.loading = true;
      await this.REMOVE_PROFILE_PHOTO();
      this.formsWaiting--;
    },
    async handleLanguagePreferencesSubmit(languagePreferences) {
      try {
        var _context2;
        this.formsWaiting++;
        await this.UPDATE_LOCALE_PREFERENCES(languagePreferences);
        this.formsWithError = _filterInstanceProperty(_context2 = this.formsWithError).call(_context2, form => form !== "languagePreferences");
      } catch (e) {
        this.formsWithError.push("languagePreferences");
      } finally {
        this.formsWaiting--;
      }
    },
    handleFormChange(form) {
      var _context3;
      if (!_includesInstanceProperty(_context3 = this.formsChanged).call(_context3, form)) this.formsChanged.push(form);
    },
    handleAllowSave(allowSave) {
      this.$emit("allow-save", this.formsChanged.length && allowSave);
    }
  })
});